import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default [{
  path: '/login',
  name: 'Login',
  redirect: '/login/documento',
  meta: {
    titulo: "Login",
    precisaAutenticacao: false,
    cabecalho: true,
    rodape: true,
    btnHelp: false,
    chat: true
  }
}, {
  path: '/login/documento',
  name: 'LoginDocumento',
  component: function component() {
    return import(/* webpackChunkName: "login" */'./pages/LoginDocumento');
  },
  meta: {
    titulo: "Login",
    precisaAutenticacao: false,
    cabecalho: true,
    rodape: true,
    btnHelp: false,
    chat: true
  },
  props: function props(route) {
    return {
      identificador: route.query.identificador
    };
  }
}];